import { render, staticRenderFns } from "./create.vue?vue&type=template&id=19f17bc6&scoped=true&"
import script from "./create.vue?vue&type=script&lang=js&"
export * from "./create.vue?vue&type=script&lang=js&"
import style0 from "./create.vue?vue&type=style&index=0&id=19f17bc6&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f17bc6",
  null
  
)

export default component.exports